export default __webpack_public_path__ + "a09cf49370c843a60de460cee16a5449.ttf";